<div class="all-in-one-table content-layout">
  <div [ngClass]="elements>5?'example-container':'none'" style="overflow-x:auto;z-index: 1;">

    <table mat-table [dataSource]="companyList" matSort (matSortChange)="sortData($event)" style="user-select:none">

      <!-- Dynamic data columns -->
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.property">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ column.name }}
        </th>
        <td mat-cell *matCellDef="let row" [ngClass]="column.cssClasses" [attr.data-label]="column.name">


          <ng-container *ngIf="column.property === 'updatedDate'">
            <a [attr.guide]="'account-companies-table-lnk-1' + '__' + sanitizedUrl" class="company-name-link mobile-truncate-table-cell"
              (click)="goToCompanyById(row.entityId)" style="cursor:pointer" [matTooltip]="getRelativeTime(row.updatedDate)">{{
              getRelativeTime(row.updatedDate) }}</a>
          </ng-container>

          <ng-container *ngIf="column.property !== 'actions' && column.property !== 'updatedDate'">
            <ng-container
              *ngIf="column.property === 'name' || column.property === 'openDealAmount' || column.property === 'wonDealAmount' || column.property === 'ownerEmail'">
              <a [attr.guide]="'account-companies-table-lnk-2' + '__' + sanitizedUrl" class="company-name-link mobile-truncate-table-cell"
                (click)="goToCompanyById(row.entityId)" style="cursor:pointer" [matTooltip]="row[column.property]">{{
                row[column.property] }}</a>
            </ng-container>
            <ng-container
              *ngIf="column.property !== 'name' && column.property !== 'openDealAmount' && column.property !== 'wonDealAmount' && column.property !== 'ownerEmail'">
              <span class="mobile-truncate-table-cell" [matTooltip]="row[column.property]">{{ row[column.property] }}</span>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="column.property=='actions'">

            <button [attr.guide]="'account-companies-table-btn-3' + '__' + sanitizedUrl" type="button" mat-icon-button
              [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
              <button [attr.guide]="'account-companies-table-btn-4' + '__' + sanitizedUrl"
                (click)="editProduct(row.entityId, row.attributeSetId)" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button [attr.guide]="'account-companies-table-btn-5' + '__' + sanitizedUrl"
                (click)="deleteAllProductId(row.entityId)" mat-menu-item>
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
          </ng-container>
        </td>

      </ng-container>


      <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable"></tr>
    </table>

    <div class="products-padding" fxLayoutAlign="center center" *ngIf="!companyList?.length">
      No records found
    </div>

    <div style="width: 100%;" *ngIf="companyList?.length>0">
      <mat-spinner fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" [diameter]="20"
        *ngIf="spinner"></mat-spinner>
      <mat-paginator fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px" class="paginator"
        (page)="getUpdate($event)" showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
        [pageSizeOptions]="pageSizeValue"> </mat-paginator>
    </div>
  </div>
</div>